import { CalendarViewTypeEnum } from 'owa-calendar-view-type';
import { getSelectedViewType } from 'owa-calendar-module-store';
import { getBrowserWidthBucket } from 'owa-layout';
import { ShouldForceFlexibleDayView } from '../constants';
import { getForcedFlexibleDayView } from './getForcedFlexibleDayView';

export function shouldForceFlexibleDayView() {
    const availableWidthBucket = getBrowserWidthBucket();

    return (
        !getForcedFlexibleDayView() &&
        getSelectedViewType() === CalendarViewTypeEnum.Weekly &&
        availableWidthBucket <= ShouldForceFlexibleDayView
    );
}

export function shouldRevertFlexibleDayView() {
    const availableWidthBucket = getBrowserWidthBucket();
    return getForcedFlexibleDayView() && availableWidthBucket > ShouldForceFlexibleDayView;
}
